import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ChatMessage, ChatbotVisualState } from '../../00_modules/ai-chatbot/models/ai-chatbot.model';
import {
    AppendAiChatbotMessage,
    ResetAiChatbotState,
    SetAiChatbotOrderContext,
    SetAiChatbotOrderContextConsent,
    SetAiChatbotOrderContextPrompted,
    SetAiChatbotOpen,
    SetAiChatbotThreadId,
    SetAiChatbotVisualState,
} from '../action/ai-chatbot.action';
import { AiChatbotState, AiChatbotStateModel } from '../state/ai-chatbot.state';

@Injectable({
    providedIn: 'root',
})
export class AiChatbotFacade {
    state$: Observable<AiChatbotStateModel> = inject(Store).select(AiChatbotState.getState);
    isOpen$: Observable<boolean> = inject(Store).select(AiChatbotState.getIsOpen);
    threadId$: Observable<string | null> = inject(Store).select(AiChatbotState.getThreadId);
    visualState$: Observable<ChatbotVisualState> = inject(Store).select(AiChatbotState.getVisualState);
    messages$: Observable<ChatMessage[]> = inject(Store).select(AiChatbotState.getMessages);
    orderContextOrderId$: Observable<number | null> = inject(Store).select(AiChatbotState.getOrderContextOrderId);
    orderContextConsent$: Observable<boolean | null> = inject(Store).select(AiChatbotState.getOrderContextConsent);
    orderContextPromptedOrderId$: Observable<number | null> = inject(Store).select(AiChatbotState.getOrderContextPromptedOrderId);

    constructor(private store: Store) {}

    public setOpen(isOpen: boolean): void {
        this.store.dispatch(new SetAiChatbotOpen(isOpen));
    }

    public setThreadId(threadId: string | null): void {
        this.store.dispatch(new SetAiChatbotThreadId(threadId));
    }

    public setVisualState(visualState: ChatbotVisualState): void {
        this.store.dispatch(new SetAiChatbotVisualState(visualState));
    }

    public setOrderContext(orderId: number | null): void {
        this.store.dispatch(new SetAiChatbotOrderContext(orderId));
    }

    public setOrderContextConsent(consent: boolean | null): void {
        this.store.dispatch(new SetAiChatbotOrderContextConsent(consent));
    }

    public setOrderContextPrompted(orderId: number | null): void {
        this.store.dispatch(new SetAiChatbotOrderContextPrompted(orderId));
    }

    public appendMessage(message: ChatMessage): void {
        this.store.dispatch(new AppendAiChatbotMessage(message));
    }

    public resetState(): void {
        this.store.dispatch(new ResetAiChatbotState());
    }
}
